import '../../ieConfig/MobxConfig'
import { types } from 'mobx-state-tree'

const Message = types
  .model('Message', {
    value: types.string,
    type: types.string,
    code: types.string,
  })
  .actions((self) => ({
    setMessage(value: string, type: string, code?: string) {
      self.value = value.toString()
      self.type = type
      self.code = code ?? ''
    },
    resetMessage() {
      self.value = ''
      self.type = ''
      self.code = ''
    },
  }))
  .views((self) => ({
    getMessage(): any {
      return {
        value: self.value,
        type: self.type,
        code: self.code,
      }
    },
  }))

const MessageInitalData = Message.create({
  value: '',
  type: 'NEGATIVE',
  code: '',
})

export { Message, MessageInitalData }
